<template>
  <RsPartialNavigationContainer
    v-if="$rsGlobals.$currentUser.isSuperUser && $rsGlobals.$env.VUE_APP_ENV !== 'demo'"
    :key="variant"
  >
    <RsPartialNavigationTree
      title="Super Admin Settings"
      icon="far fa-cog rs-text-tertiary-medium-purple"
      active-icon="fas fa-cog rs-text-primary"
      icon-size="lg"
      class="rs-text-white"
      :variant="variant as NavigationTreeVariantType"
      :expanded="expanded"
      :active="routeStartsWith('/superadmin-account-settings')"
    >
      <RsPartialNavigationTreeBranch
        title="Languages"
        :to="{ name: 'SuperAdminLanguageSettings' }"
        :active="routeEndsWith('/superadmin-account-settings/language')"
      />
      <RsPartialNavigationTreeBranch
        title="Modules"
        :to="{ name: 'SuperAdminSettingsModules' }"
        :active="routeEndsWith('/superadmin-account-settings/modules')"
      />
      <RsPartialNavigationTreeBranch
        title="Integrations"
        :to="{ name: 'SuperAdminSettingsIntegrations' }"
        :active="routeEndsWith('/superadmin-account-settings/integrations')"
      />
      <RsPartialNavigationTreeBranch
        title="Building Stack Settings"
        :to="{ name: 'SuperAdminBuildingStackSettings' }"
        :active="routeEndsWith('/superadmin-account-settings/bstk-settings')"
      />
    </RsPartialNavigationTree>
  </RsPartialNavigationContainer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RsPartialNavigationContainer from '@/components/RsPartialNavigationContainer.vue';
import RsPartialNavigationTree, { NavigationTreeVariantType } from '@/components/RsPartialNavigationTree.vue';
import RsPartialNavigationTreeBranch from '@/components/RsPartialNavigationTreeBranch.vue';
import { routeEndsWith, routeStartsWith } from '@/shared/helpers/navigation-active-helpers';

export default defineComponent({
  components: {
    RsPartialNavigationContainer,
    RsPartialNavigationTree,
    RsPartialNavigationTreeBranch,
  },

  props: {
    variant: {
      type: String,
      default: 'collapse',
    },

    expanded: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    routeStartsWith,
    routeEndsWith,
  },
});
</script>
